function isMobile() {
  return window.innerWidth <= 750;
}

function toggleOpenAttribute() {
  const detailsElement = document.querySelector('.product-main-downloads');
  if (detailsElement) {
    if (isMobile()) {
      detailsElement.removeAttribute('open');
    } else {
      detailsElement.setAttribute('open', true);
    }
  }
}

window.addEventListener('DOMContentLoaded', toggleOpenAttribute);
window.addEventListener('resize', toggleOpenAttribute);

function openQrModal() {
  const button = document.querySelector("#open-qr-modal")
  const modal = document.querySelector(".qr-modal")
  const closeButton = modal?.querySelector(".qr-modal-close")

  button?.addEventListener("click", (e) => {
    e.preventDefault()
    modal.classList.add("show")
  })

  closeButton?.addEventListener("click", () => {
    modal.classList.remove("show")
  })
}

openQrModal()